import { useState } from 'react';
import AdjuntosList from './AdjuntosList.jsx';
import './vehiculos.css';

export default function VehiculoDocsForm({ value, onChange, errors }) {
  const [nuevoAdjunto, setNuevoAdjunto] = useState('');

  const handleChange = (field, fieldValue) => {
    if (typeof onChange === 'function') {
      onChange({ ...value, [field]: fieldValue });
    }
  };

  const handleAddAdjunto = event => {
    event.preventDefault();
    const path = nuevoAdjunto.trim();
    if (!path) {
      return;
    }
    const adjuntos = Array.isArray(value.adjuntos) ? value.adjuntos : [];
    if (adjuntos.includes(path)) {
      setNuevoAdjunto('');
      return;
    }
    handleChange('adjuntos', [...adjuntos, path]);
    setNuevoAdjunto('');
  };

  const handleRemoveAdjunto = path => {
    const adjuntos = Array.isArray(value.adjuntos) ? value.adjuntos : [];
    handleChange('adjuntos', adjuntos.filter(item => item !== path));
  };

  return (
    <div className="form-section">
      <div className="form-field" data-error={Boolean(errors?.vtvNumero)}>
        <label htmlFor="vehiculo-vtv-numero">VTV - Número</label>
        <input
          id="vehiculo-vtv-numero"
          name="vtvNumero"
          value={value.vtvNumero ?? ''}
          onChange={event => handleChange('vtvNumero', event.target.value)}
        />
        {errors?.vtvNumero && <span className="field-error">{errors.vtvNumero}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.vtvEmision)}>
        <label htmlFor="vehiculo-vtv-emision">VTV - Fecha emisión</label>
        <input
          id="vehiculo-vtv-emision"
          name="vtvEmision"
          type="date"
          value={value.vtvEmision ?? ''}
          onChange={event => handleChange('vtvEmision', event.target.value)}
        />
        {errors?.vtvEmision && <span className="field-error">{errors.vtvEmision}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.vtvVencimiento)}>
        <label htmlFor="vehiculo-vtv-vencimiento">VTV - Fecha vencimiento *</label>
        <input
          id="vehiculo-vtv-vencimiento"
          name="vtvVencimiento"
          type="date"
          value={value.vtvVencimiento ?? ''}
          onChange={event => handleChange('vtvVencimiento', event.target.value)}
          required
        />
        {errors?.vtvVencimiento && <span className="field-error">{errors.vtvVencimiento}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.vtvAvisoDias)}>
        <label htmlFor="vehiculo-vtv-aviso">Recordatorio VTV (días antes)</label>
        <input
          id="vehiculo-vtv-aviso"
          name="vtvAvisoDias"
          type="number"
          min="0"
          value={value.vtvAvisoDias ?? 30}
          onChange={event => handleChange('vtvAvisoDias', event.target.value ? Number(event.target.value) : 0)}
        />
        {errors?.vtvAvisoDias && <span className="field-error">{errors.vtvAvisoDias}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.seguroCompania)}>
        <label htmlFor="vehiculo-seguro-compania">Seguro - Compañía</label>
        <input
          id="vehiculo-seguro-compania"
          name="seguroCompania"
          value={value.seguroCompania ?? ''}
          onChange={event => handleChange('seguroCompania', event.target.value)}
        />
        {errors?.seguroCompania && <span className="field-error">{errors.seguroCompania}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.seguroPoliza)}>
        <label htmlFor="vehiculo-seguro-poliza">Seguro - Póliza</label>
        <input
          id="vehiculo-seguro-poliza"
          name="seguroPoliza"
          value={value.seguroPoliza ?? ''}
          onChange={event => handleChange('seguroPoliza', event.target.value)}
        />
        {errors?.seguroPoliza && <span className="field-error">{errors.seguroPoliza}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.seguroVencimiento)}>
        <label htmlFor="vehiculo-seguro-vencimiento">Seguro - Vencimiento *</label>
        <input
          id="vehiculo-seguro-vencimiento"
          name="seguroVencimiento"
          type="date"
          value={value.seguroVencimiento ?? ''}
          onChange={event => handleChange('seguroVencimiento', event.target.value)}
          required
        />
        {errors?.seguroVencimiento && <span className="field-error">{errors.seguroVencimiento}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.seguroFranquicia)}>
        <label htmlFor="vehiculo-seguro-franquicia">Seguro - Franquicia</label>
        <input
          id="vehiculo-seguro-franquicia"
          name="seguroFranquicia"
          value={value.seguroFranquicia ?? ''}
          onChange={event => handleChange('seguroFranquicia', event.target.value)}
        />
        {errors?.seguroFranquicia && <span className="field-error">{errors.seguroFranquicia}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.cedulaVerdeVto)}>
        <label htmlFor="vehiculo-cedula-verde">Cédula verde - Vencimiento</label>
        <input
          id="vehiculo-cedula-verde"
          name="cedulaVerdeVto"
          type="date"
          value={value.cedulaVerdeVto ?? ''}
          onChange={event => handleChange('cedulaVerdeVto', event.target.value)}
        />
        {errors?.cedulaVerdeVto && <span className="field-error">{errors.cedulaVerdeVto}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.cedulaAzulVto)}>
        <label htmlFor="vehiculo-cedula-azul">Cédula azul - Vencimiento</label>
        <input
          id="vehiculo-cedula-azul"
          name="cedulaAzulVto"
          type="date"
          value={value.cedulaAzulVto ?? ''}
          onChange={event => handleChange('cedulaAzulVto', event.target.value)}
        />
        {errors?.cedulaAzulVto && <span className="field-error">{errors.cedulaAzulVto}</span>}
      </div>

      <div className="form-field form-field--adjuntos dual-columns">
        <label htmlFor="vehiculo-adjunto">Adjuntos</label>
        <div className="form-control-group">
          <input
            id="vehiculo-adjunto"
            value={nuevoAdjunto}
            onChange={event => setNuevoAdjunto(event.target.value)}
            placeholder="vtv_2025.pdf"
          />
          <button type="button" className="btn btn--secondary" onClick={handleAddAdjunto}>
            Añadir
          </button>
        </div>
        <AdjuntosList items={value.adjuntos ?? []} onRemove={handleRemoveAdjunto} />
      </div>
    </div>
  );
}
